module.exports = __webpack_public_path__ + "img/omissionSpince.aebe9657.png";